import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UpgradeModule } from '@angular/upgrade/static';

import { IbGiftCardsNewContributionComponent } from './ib-gift-cards-new-contribution.component';
import { IbGiftCardsNewContributionFormComponent } from '../ib-gift-cards-new-contribution-form/ib-gift-cards-new-contribution-form.component';
import { ibGiftContributionCardComponent } from '../ib-gift-cards-contribution-card/ib-gift-cards-contribution-card.component';
import { ibGiftCardContributionModal } from '@src/app/shared/modals/contribution/ib-gift-cards-simple-contribution-modal/ib-gift-cards-simple-contribution-modal';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        IbGiftCardsNewContributionComponent
    ],
    exports: [
        IbGiftCardsNewContributionComponent
    ],
    imports: [
        CommonModule,
        UpgradeModule,
        TranslateModule,
        IbGiftCardsNewContributionFormComponent,
        ibGiftContributionCardComponent,
        ibGiftCardContributionModal
    ]
})

export class IbGiftCardsNewContributionModule { }
export { IbGiftCardsNewContributionComponent } from './ib-gift-cards-new-contribution.component';
